// src/Auth/authHelpers.js
// Central helper for constructing the Authorization header used on every
// backend fetch. Backs the shift from the old (unsafe) x-trainer-id header
// to a validated Azure AD bearer token.
//
// Usage:
//   headers: await getAuthHeaders(trainerID)
//
// The trainerID arg is retained for logging/telemetry only; the backend
// derives identity from the JWT.

import pca, { loginRequest } from "./msalConfig";

async function acquireIdToken() {
	const accounts = pca.getAllAccounts();
	if (!accounts.length) {
		throw new Error("Not signed in");
	}
	const account = accounts[0];

	try {
		const result = await pca.acquireTokenSilent({
			...loginRequest,
			account,
		});
		return result.idToken;
	} catch (err) {
		// Silent acquisition can fail if the cached token is stale and the
		// session cookie is gone. Fall back to interactive so the user gets
		// re-prompted rather than silently unauthenticated.
		if (
			err &&
			(err.name === "InteractionRequiredAuthError" ||
				err.errorCode === "interaction_required" ||
				err.errorCode === "login_required" ||
				err.errorCode === "consent_required")
		) {
			const result = await pca.acquireTokenPopup(loginRequest);
			return result.idToken;
		}
		throw err;
	}
}

export async function getAuthHeaders(trainerID) {
	const token = await acquireIdToken();
	const headers = {
		Authorization: `Bearer ${token}`,
	};
	if (trainerID) headers["x-trainer-id"] = trainerID;
	return headers;
}
